import React from "react";
import { isNumber } from "lodash";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { content } from "@glossy";
import { getPlatformLabel } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import Icon from "@ui-kit/icon";
import Scores from "@radarly/components/post/scores";
import { tr } from "@radarly/i18n";
import { Post } from "@radarly/models/posts";

interface IProps {
  post: Post;
  locale: Locale;
  views?: number;
}

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Infos = styled.div`
  display: flex;
  align-items: center;
  &:nth-child(1) {
    color: ${(props) => content(props, "secondary")};
  }
`;

const Platform = styled.div`
  display: flex;
  align-items: center;
`;

const PlatformName = styled.div`
  margin: 0 12px 0 6px;
  font-size: 14px;
  color: ${content};
`;

const Views = styled.span`
  color: ${(props) => content(props, "secondary")};
  font-size: 14px;
  margin-right: 12px;
`;

const RadarlyPostFooter = ({ post, views, locale }: IProps) => {
  return (
    <Root>
      <Infos>
        <Platform>
          <Icon glyph={post.origin.platform} />
          <PlatformName>
            {getPlatformLabel(locale, post.origin.platform)}
          </PlatformName>
          {isNumber(views) && (
            <Views>
              {tr(locale, "POST_VIEWS", { count: shorten(locale, views) })}
            </Views>
          )}
        </Platform>
      </Infos>
      <Scores locale={locale} post={post} />
    </Root>
  );
};

export default RadarlyPostFooter;
